<!--begin::Form group-->

<form [formGroup]="newUserForm">

  <!--begin::Form group-->
  <div class="fv-row mb-7">
    <label class="form-label fw-bolder text-dark fs-6">Email</label>
    <input
      class="form-control form-control-lg form-control-solid"
      type="email"
      placeholder="Email"
      name="email"
      formControlName="email"
      autocomplete="chrome-off"
      [ngClass]="{
        'is-invalid': newUserForm.controls['email'].invalid && newUserForm.controls['email'].touched,
        'is-valid': newUserForm.controls['email'].valid
      }"
    />
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'required',
        message: 'Email is required',
        control: newUserForm.controls['email']
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'email',
        message: 'Email is invalid',
        control: newUserForm.controls['email']
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'minlength',
        message: 'Email should have at least 3 symbols',
        control: newUserForm.controls['email']
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'maxLength',
        message: 'Email should have maximum 360 symbols',
        control: newUserForm.controls['email']
      }"
    ></ng-container>
  </div>
  <!--end::Form group-->

  <!--begin::Form group-->
  <div class="fv-row mb-7">
    <label class="form-label fw-bolder text-dark fs-6">User Role</label>
    <select formControlName="role" class="form-control form-control-solid">
      <option value="user">User</option>
      <option value="admin">Admin</option>
    </select>
  </div>
  <!--end::Form group-->


  <div *ngIf="errorMessage$ | async" class="bg-light-warning rounded border-warning border border-dashed p-6">
    <h4 class="text-danger">There has been an error.</h4>
    <p>{{errorMessage$ | async}}</p>
  </div>


</form>

<div *nzModalFooter>
  <button class="btn btn-light-primary btn-sm me-2" (click)="destroyModal()">Cancel</button>
  <button
    type="button"
    (click)="submitForm()"
    id="qrpay_sign_up_submit"
    [disabled]="
        newUserForm.invalid || (isLoading$ | async)
      "
    class="btn btn-sm btn-theme"
  >
    <ng-container *ngIf="(isLoading$ | async) === false">
      <span class="indicator-label">Submit</span>
    </ng-container>
    <ng-container *ngIf="isLoading$ | async">
        <span class="indicator-progress" [style.display]="'block'">
          Please wait...
          <span
            class="spinner-border spinner-border-sm align-middle ms-2"
          ></span>
        </span>
    </ng-container>
  </button>
</div>


<ng-template
  #formError
  let-control="control"
  let-message="message"
  let-validation="validation"
>
  <ng-container
    *ngIf="control.hasError(validation) && (control.dirty || control.touched)"
  >
    <div class="fv-plugins-message-container">
      <div class="fv-help-block">
        <span role="alert">
          {{ message }}
        </span>
      </div>
    </div>
  </ng-container>
</ng-template>
